import { CmsComponentTypeEnum } from '@models/enums';
import { BaseComponentConfig, Card } from './';

export namespace CardsSlider {
  export const TypeEnum = CmsComponentTypeEnum.CARDS_SLIDER;

  export interface CardConfig extends Card.ComponentConfig {
    copy?: boolean;
  }

  export interface ComponentConfig extends BaseComponentConfig {
    slides: CardConfig[];
  }
}
